import type { IconType } from 'react-icons';
import { motion } from 'framer-motion';
import { Card, IconMedallion } from '../../../design-system/components';

interface ScenarioCardProps {
  icon: IconType;
  title: string;
  description: string;
  index: number;
}

/**
 * One illustrative situation on the landing page: who it is for and what the
 * app gives them. Deliberately not a testimonial: no speaker, no quotation,
 * no avatar, no star rating. None of these are real people.
 */
export default function ScenarioCard({ icon, title, description, index }: ScenarioCardProps) {
  return (
    <motion.div
      className="ee-landing-cell"
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: index * 0.12 }}
    >
      <Card padding="lg" data-testid="scenario-card">
        <IconMedallion icon={icon} size="sm" />
        <h3 className="ee-landing-tile__title ee-landing-scenario__title">{title}</h3>
        <p className="ee-landing-tile__text">{description}</p>
      </Card>
    </motion.div>
  );
}
